import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMailDotRuComponent } from './simple-icons-mail-dot-ru.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMailDotRuComponent ],
    exports:      [ SimpleIconsMailDotRuComponent ],
    bootstrap:    []
})
export class SimpleIconsMailDotRuModule {}
